import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import { Grid, Typography } from '@mui/material';
import { useState } from 'react';

const ComplianceHelper = ({}: any) => {
  const [closeHelper, setCloseHelper] = useState(false);

  return closeHelper ? (
    <></>
  ) : (
    <Grid item>
      <Grid
        container
        direction="row"
        justifyContent="center"
        border={1}
        borderRadius={1}
        padding={2}
        flexWrap="nowrap"
      >
        <Grid item xs={0.5} style={{ textAlign: 'center' }} minWidth={40}>
          {' '}
          <InfoIcon htmlColor="#080A2D" />
        </Grid>
        <Grid item xs={11}>
          <Typography
            variant="body1"
            fontWeight={'500'}
            color={'primary.main'}
          >
            Hi, we’re TheGuarantors. We have partnered with your building to
            validate your insurance
          </Typography>
          <Typography
            variant="body1"
            color={'primary.main'}
          >
            Your building requires that all residents purchase renters insurance
            that meets their requirements. Please fill out the information below
            to validate your renters insurance policy. Once we have validated
            your policy we will notify the building so they know you’re covered.
          </Typography>
        </Grid>
        <Grid item xs={0.5} style={{ textAlign: 'center' }} minWidth={40}>
          <CloseIcon
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              setCloseHelper(true);
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ComplianceHelper;
